import { URL_OFFER_PROPOSAL_ARCHIVE, URL_OFFER_PROPOSAL_UPDATE } from '@tools/routes/routes';
import { flashBagError } from '@tools/flashbag';
import requests from '@tools/requests';
import Logger from '@tools/logger/logger';

export const apiArchiveProposal = async (proposalId: number): Promise<boolean> => {
  try {
    await requests.patch(URL_OFFER_PROPOSAL_ARCHIVE.replace('{id}', String(proposalId)));
    return true;
  } catch (error) {
    flashBagError();
    Logger.error(error);
  }

  return false;
};

interface UpdateProposalParams {
  comment: string,
}

export const apiUpdateProposal = async (
  proposalId: number,
  params: UpdateProposalParams,
): Promise<boolean> => {
  try {
    await requests.patch(
      URL_OFFER_PROPOSAL_UPDATE.replace('{id}', String(proposalId)),
      JSON.stringify(params),
    );

    return true;
  } catch (error) {
    Logger.error(error);
  }

  return false;
};
